import { formatMinor } from '../../../shared/utils/money';
import type { DepositRule } from '../types';

/** Charter providers operate in WAT (Africa/Lagos). Slot/booking times render there. */
export const WAT_TIMEZONE = 'Africa/Lagos';

/** Format an ISO timestamp as a date + time in WAT (e.g. "20 Jul 2026, 10:00"). */
export function formatWat(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: WAT_TIMEZONE,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
}

/** Date only, in WAT. */
export function formatWatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: WAT_TIMEZONE,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(d);
}

/** Money formatter: free when 0, otherwise minor-units → symbol + amount. */
export function formatPrice(amountMinor: number | null | undefined, currency = 'NGN'): string {
  if (!amountMinor) return 'Free';
  return formatMinor(amountMinor, currency);
}

/** Human summary of a deposit rule for list rows. */
export function depositRuleLabel(rule: DepositRule | null | undefined): string {
  if (!rule) return '—';
  switch (rule.type) {
    case 'none':
      return 'No deposit';
    case 'percentage':
      return `${rule.percentageValue ?? 0}% deposit`;
    case 'full':
      return 'Full upfront';
    default:
      return '—';
  }
}

export const DAY_OF_WEEK_LABELS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
